export default __webpack_public_path__ + "static/media/limb_main_mobile@2x.844e30b9.jpg";